import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f6506ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อเรื่อง"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จังหวัด"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "รายงานเมื่อ")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["data-bs-content"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cube me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceTasks, (task, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "row-hover",
                  onClick: ($event: any) => (_ctx.selectedClick(task.id))
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", {
                    class: "column-name text-truncate",
                    "data-bs-toggle": "popover-task",
                    "data-bs-content": task.name
                  }, [
                    _hoisted_6,
                    _createTextVNode(_toDisplayString(task.name), 1)
                  ], 8, _hoisted_5),
                  _createElementVNode("td", null, _toDisplayString(task.province.name), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(task.provinceTaskDate)), 1)
                ], 8, _hoisted_4))
              }), 128))
            ])
          ], 512)
        ]))
  ]))
}